import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
  Tooltip,
  Fade,
  // Zoom,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  // alpha,
} from "@mui/material";
import {
  AccountCircle as AccountCircleIcon,
  Dashboard as DashboardIcon,
  Devices as DevicesIcon,
  Home as HomeIcon,
  Logout as LogoutIcon,
  AdminPanelSettings as AdminIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  // Settings as SettingsIcon,
  // Security as SecurityIcon,
} from "@mui/icons-material";
import forest_fire_new_logo from "../../images/forest_fire_new_logo.jpeg";
import fireLogo from "../../images/firelogo.jpeg";

export default function TopAppBar() {
  const history = useHistory();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const organization = user.organization || "CVGL";
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 900px)");

  const logo =
    user?.username === "punjabadmin" ? forest_fire_new_logo : fireLogo;
  const logoSize = user?.username === "punjabadmin" ? "100" : "100";

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (path) => {
    history.push(path);
    handleMenuClose();
    setMobileDrawerOpen(false);
  };

  const handleAdminClick = () => {
    window.location = "https://api.forestwatch.org.pk/admin";
    handleMenuClose();
  };

  const handleLogout = () => {
    window.location = "/logout";
    handleMenuClose();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: "/", label: "Home", icon: <HomeIcon /> },
    { path: "/dashboard", label: "Dashboard", icon: <DashboardIcon /> },
    { path: "/devices", label: "Devices", icon: <DevicesIcon /> },
  ];

  // Gradient styles
  const gradientBar = {
    background:
      "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    backdropFilter: "blur(10px)",
  };

  const buttonStyle = (isActivePath) => ({
    borderRadius: "30px",
    padding: "8px 24px",
    margin: "0 6px",
    transition: "all 0.3s ease",
    textTransform: "none",
    fontSize: "15px",
    fontWeight: 600,
    backgroundColor: isActivePath ? "rgba(255,255,255,0.25)" : "transparent",
    color: isActivePath ? "white" : "rgba(255,255,255,0.9)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
      transform: "translateY(-2px)",
    },
  });

  const iconButtonStyle = {
    borderRadius: "50%",
    padding: "10px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
      transform: "scale(1.05)",
    },
  };

  const menuPaperStyle = {
    borderRadius: "16px",
    minWidth: "180px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    overflow: "hidden",
  };

  const menuItemStyle = {
    py: 1.5,
    px: 2.5,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f0f0f0",
      transform: "translateX(4px)",
    },
  };

  const mobileDrawerStyle = {
    width: "200px",
    background: "linear-gradient(180deg, #454545 0%, #2d2d2d 100%)",
    color: "white",
  };

  return (
    <>
      <AppBar position="fixed" sx={gradientBar} elevation={0}>
        <Toolbar sx={{ justifyContent: "space-between", minHeight: "10px" }}>
          {/* Logo Section */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link
              to="/"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <img
                src={logo}
                alt="Project Logo"
                style={{
                  width: logoSize,
                  height: "50px",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                  borderRadius: "10px",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.02)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </Link>
          </Box>

          {/* Desktop Navigation */}
          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {navItems.map((item) => (
                <Tooltip title={item.label} key={item.path} arrow>
                  <Button
                    onClick={() => handleNavigation(item.path)}
                    sx={buttonStyle(isActive(item.path))}
                  >
                    {item.label}
                  </Button>
                </Tooltip>
              ))}

              {/* Profile Button */}
              <Tooltip title="Account" arrow>
                <IconButton
                  onClick={handleMenuOpen}
                  sx={iconButtonStyle}
                  aria-controls="profile-menu"
                  aria-haspopup="true"
                >
                  <Avatar
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      width: 40,
                      height: 40,
                      transition: "all 0.3s ease",
                    }}
                  >
                    <AccountCircleIcon sx={{ fontSize: 28, color: "white" }} />
                  </Avatar>
                </IconButton>
              </Tooltip>
            </Box>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <Tooltip title="Menu" arrow>
              <IconButton
                onClick={() => setMobileDrawerOpen(true)}
                sx={iconButtonStyle}
              >
                <MenuIcon sx={{ color: "white", fontSize: 28 }} />
              </IconButton>
            </Tooltip>
          )}
        </Toolbar>
      </AppBar>

      {/* Profile Dropdown Menu */}
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        TransitionComponent={Fade}
        PaperProps={{ sx: menuPaperStyle }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box sx={{ p: 2, textAlign: "center", bgcolor: "#f8f9fa" }}>
          <Avatar
            sx={{
              width: 60,
              height: 60,
              mx: "auto",
              mb: 1,
              bgcolor: "#454545",
            }}
          >
            <AccountCircleIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: "#333" }}
          >
            {user.username || "User"}
          </Typography>
          <Typography variant="caption" sx={{ color: "#666" }}>
            {organization === "CVGL" ? "Administrator" : "User"}
          </Typography>
        </Box>
        <Divider />

        {organization === "CVGL" && (
          <MenuItem onClick={handleAdminClick} sx={menuItemStyle}>
            <AdminIcon sx={{ mr: 2, fontSize: 20, color: "#454545" }} />
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Admin Panel
            </Typography>
          </MenuItem>
        )}

        <MenuItem
          onClick={handleLogout}
          sx={{ ...menuItemStyle, "&:hover": { backgroundColor: "#fff5f5" } }}
        >
          <LogoutIcon sx={{ mr: 2, fontSize: 20, color: "#e74c3c" }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#e74c3c" }}
          >
            Logout
          </Typography>
        </MenuItem>
      </Menu>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
        PaperProps={{ sx: mobileDrawerStyle }}
      >
        <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            onClick={() => setMobileDrawerOpen(false)}
            sx={{ color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ textAlign: "center", py: 2 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              mx: "auto",
              mb: 2,
              bgcolor: "rgba(255,255,255,0.2)",
            }}
          >
            <AccountCircleIcon sx={{ fontSize: 50, color: "white" }} />
          </Avatar>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "white" }}>
            {user.username || "User"}
          </Typography>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)" }}>
            {organization === "CVGL" ? "Administrator" : "User"}
          </Typography>
        </Box>

        <Divider sx={{ bgcolor: "rgba(255,255,255,0.1)", my: 2 }} />

        <List sx={{ px: 2 }}>
          {navItems.map((item) => (
            <ListItem
              key={item.path}
              onClick={() => handleNavigation(item.path)}
              sx={{
                borderRadius: "12px",
                mb: 1,
                cursor: "pointer",
                transition: "all 0.3s ease",
                bgcolor: isActive(item.path)
                  ? "rgba(255,255,255,0.15)"
                  : "transparent",
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.1)",
                  transform: "translateX(8px)",
                },
              }}
            >
              <ListItemIcon sx={{ color: "white", minWidth: "40px" }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  sx: { fontWeight: 600, color: "white" },
                }}
              />
            </ListItem>
          ))}

          {organization === "CVGL" && (
            <ListItem
              onClick={handleAdminClick}
              sx={{
                borderRadius: "12px",
                mb: 1,
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.1)",
                  transform: "translateX(8px)",
                },
              }}
            >
              <ListItemIcon sx={{ color: "white", minWidth: "40px" }}>
                <AdminIcon />
              </ListItemIcon>
              <ListItemText
                primary="Admin Panel"
                primaryTypographyProps={{
                  sx: { fontWeight: 600, color: "white" },
                }}
              />
            </ListItem>
          )}

          <Divider sx={{ bgcolor: "rgba(255,255,255,0.1)", my: 2 }} />

          <ListItem
            onClick={handleLogout}
            sx={{
              borderRadius: "12px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                bgcolor: "rgba(231,76,60,0.2)",
                transform: "translateX(8px)",
              },
            }}
          >
            <ListItemIcon sx={{ color: "#ff6b6b", minWidth: "40px" }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{
                sx: { fontWeight: 700, color: "#ff6b6b" },
              }}
            />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
}
